import { Badge, Group, Paper, Text } from '@mantine/core';
import { format, parseISO } from 'date-fns';
import { useAccountByIdData } from '../hooks/useAccountData.ts';
import { SectionState } from './SectionState.tsx';
import type { ComponentProps } from 'react';

const PROVIDER_LABEL: Record<string, string> = {
  RECUR: 'Recur',
  PLAY_STORE: 'Google Play',
  APP_STORE: 'App Store',
};

const DATE_TIME_FORMAT = 'yyyy/MM/dd HH:mm:ss';

const StateCard = (props: ComponentProps<typeof SectionState>) => (
  <Paper radius="lg" p="xl" shadow="xs">
    <SectionState {...props} />
  </Paper>
);

const AccountSubscriptionsSection = ({ accountId }: { accountId: string }) => {
  const { data, error, isPending } = useAccountByIdData(accountId);

  if (isPending) return <StateCard status="loading" />;
  if (error) return <StateCard status="error" error={error} />;

  const { subscription } = data;
  if (!subscription) {
    return <StateCard status="empty" message="沒有生效中訂閱資料" />;
  }

  return (
    <Group gap="md" align="stretch" wrap="nowrap">
      <Paper
        radius="lg"
        p="xl"
        shadow="xs"
        style={{ flex: '1 1 0', minWidth: 0 }}
      >
        <Text size="xs" c="dimmed">
          訂閱平台
        </Text>
        <Text mt={4}>
          {PROVIDER_LABEL[subscription.subscriptionProvider] ??
            subscription.subscriptionProvider}
        </Text>
      </Paper>
      <Paper
        radius="lg"
        p="xl"
        shadow="xs"
        style={{ flex: '1 1 0', minWidth: 0 }}
      >
        <Text size="xs" c="dimmed">
          訂閱方案
        </Text>
        <Text mt={4}>{subscription.plan.name}</Text>
      </Paper>
      <Paper
        radius="lg"
        p="xl"
        shadow="xs"
        style={{ flex: '2 1 0', minWidth: 0 }}
      >
        <Group gap="xs">
          <Text size="xs" c="dimmed">
            方案開始/結束時間
          </Text>
          {subscription.willAutoRenew === false && (
            <Badge color="red" variant="light">
              已取消自動續訂
            </Badge>
          )}
        </Group>
        <Text mt={4}>
          {format(parseISO(subscription.startDateTime), DATE_TIME_FORMAT)} -{' '}
          {format(parseISO(subscription.endDateTime), DATE_TIME_FORMAT)}
        </Text>
      </Paper>
    </Group>
  );
};

export { AccountSubscriptionsSection };
